import UploadFile from "./UploadFile";

export default class UploadedFile extends UploadFile {
	constructor({
		added_on,
		bucket_path,
		category_id,
		category_json_base,
		category,
		company_id,
		id,
		is_public,
		original_name,
		process_state,
		resource_id,
		typology_id,
		typology_name,
		update_on,
	}) {
		super({bucket_path, id, is_public, original_name, typology_id});
		this.added_on = added_on || "";
		this.category_id = category_id || 0;
		this.category_json_base = category_json_base || {};
		this.category = category || "";
		this.company_id = company_id || 0;
		this.process_state = process_state || "";
		this.resource_id = resource_id || 0;
		this.typology_name = typology_name || "";
		this.update_on = update_on || "";
	}
}
